import { XY } from "../../xy";
import { BigContainer } from "../../things/bigContainer";
import { LootBox } from "../../things/lootBox";
import { MedicalLootBox } from "../../things/medicalLootBox";
import { MetalLootBox } from "../../things/metalLootBox";
import type { Prefab } from "../prefab";
import { buildPrefab, buildPrefabWithOverrides } from "./prefabBuilder";
import {
	desksData,
	plantsCornerData,
	borderData,
	deskData,
	woodenDesksData,
	shelvesData,
	computerDesksData,
	singleComputerDeskData,
	barrelsOnWallData,
	explosiveBarrelsOnWallData,
	explosiveBarrelsData,
	machinesWithWarningStripesData,
	offlineRobotsData,
	offlineRobots2Data,
	fenceWithPlantsData,
	fencedLootBoxesData,
	metalCornerData,
	cornerPrisonCellData,
	fenceBoxesData,
	pillarsData,
	bigContainerData,
} from "./robotBasePrefabData";

export function getDesksPrefab(): Prefab {
	return buildPrefab(desksData);
}

export function getPlantsCornerPrefab(): Prefab {
	return buildPrefab(plantsCornerData);
}

export function getMetalCornerPrefab(wallClass: string): Prefab {
	return buildPrefabWithOverrides(metalCornerData, { W: wallClass });
}

export function getBorderPrefab(): Prefab {
	return buildPrefab(borderData);
}

export function getDeskPrefab(): Prefab {
	return buildPrefab(deskData);
}

export function getCornerPrisonCellPrefab(wallClass: string): Prefab {
	return buildPrefabWithOverrides(cornerPrisonCellData, { W: wallClass });
}

export function getWoodenDesksPrefab(): Prefab {
	return buildPrefab(woodenDesksData);
}

export function getShelvesPrefab(): Prefab {
	return buildPrefab(shelvesData);
}

export function getComputerDesksPrefab(): Prefab {
	return buildPrefab(computerDesksData);
}

export function getSingleComputerDeskPrefab(): Prefab {
	return buildPrefab(singleComputerDeskData);
}

export function getFenceBoxesPrefab(wallClass: string): Prefab {
	return buildPrefabWithOverrides(fenceBoxesData, { W: wallClass });
}

export function getBarrelsOnWallPrefab(): Prefab {
	return buildPrefab(barrelsOnWallData);
}

export function getExplosiveBarrelsOnWallPrefab(): Prefab {
	return buildPrefab(explosiveBarrelsOnWallData);
}

export function getExplosiveBarrelsPrefab(): Prefab {
	return buildPrefab(explosiveBarrelsData);
}

export function getPillarsPrefab(wallClass: string): Prefab {
	return buildPrefabWithOverrides(pillarsData, { W: wallClass });
}

export function getMachinesWithWarningStripesPrefab(): Prefab {
	return buildPrefab(machinesWithWarningStripesData);
}

export function getOfflineRobots(): Prefab {
	return buildPrefab(offlineRobotsData);
}

export function getOfflineRobots2(): Prefab {
	return buildPrefab(offlineRobots2Data);
}

export function getFenceWithPlants(): Prefab {
	return buildPrefab(fenceWithPlantsData);
}

export function getFencedLootBoxesPrefab(): Prefab {
	return buildPrefab(fencedLootBoxesData);
}

export function getBigContainerPrefab(): Prefab {
	const prefab = buildPrefab(bigContainerData);
	const bigContainer = prefab.simpleBoard.getThingList().find((t) => t instanceof BigContainer) as BigContainer;
	bigContainer.addLoot(new MetalLootBox(new XY(0, 0)));
	bigContainer.addLoot(new LootBox(new XY(0, 0)));
	bigContainer.addLoot(new LootBox(new XY(0, 0)));
	bigContainer.addLoot(new MedicalLootBox(new XY(0, 0)));
	return prefab;
}
